import ormRoutes from './orm';   // 조직
import envRoutes from './env';   // 환경
import phmRoutes from './phm';   // 인사
import camRoutes from './cam';   // 발령
import dtsRoutes from './dts';   // 근퇴
import elaRoutes from './ela';   // 결재
import payRoutes from './pay';   // 보상
import devRoutes from './dev';   // 개발
import generatedRoutes from './_generated';

const routes = [
  {
    path: '/',
    component: () => import('@/layouts/MainLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        // 홈 위젯 대시보드 - 로그인 후 최초 진입(랜딩). route.name = OBJECT_ID(HOM0010).
        path: '',
        name: 'HOM0010',
        component: () => import('@/pages/home/HOM0010.vue'),
        meta: { requiresAuth: true, title: '홈', menuId: 'HOM0010', objInfo: 'HOM0010 · 홈(위젯 대시보드)' },
      },
      {
        // 하위호환: 기존 'Dashboard' 네임 참조(가드·로그인 리다이렉트·catch-all)를 홈으로 흡수.
        path: 'dashboard',
        name: 'Dashboard',
        redirect: { name: 'HOM0010' },
      },
      {
        // 홈 위젯 배치 편집기 - 환경설정>기본 설정 메뉴. 홈(HOM0010)은 읽기 전용이라 배치 편집은 여기서만 한다.
        path: 'env/home-widget',
        name: 'HOM0020',
        component: () => import('@/pages/home/HOM0020.vue'),
        meta: { requiresAuth: true, title: '홈 위젯', menuId: 'HOM0020', objInfo: 'HOM0020 · 환경설정>기본 설정' },
      },
      {
        // 공지사항 - 홈 위젯 [더보기] 진입. route.name = OBJECT_ID(CMU0010).
        path: 'notice',
        name: 'CMU0010',
        component: () => import('@/pages/home/CMU0010.vue'),
        meta: { requiresAuth: true, title: '공지사항', menuId: 'CMU0010', objInfo: 'CMU0010 · 홈/공지사항' },
      },
      {
        // 인사잇 알림 - LNB 종 [더보기]·홈 알림 위젯 진입. route.name = OBJECT_ID(ALM0010).
        path: 'notify',
        name: 'ALM0010',
        component: () => import('@/pages/home/ALM0010.vue'),
        meta: { requiresAuth: true, title: '내 알림', menuId: 'ALM0010', objInfo: 'ALM0010 · 홈/내 알림' },
      },
      ...ormRoutes,         // 조직
      ...envRoutes,         // 환경
      ...phmRoutes,         // 인사
      ...camRoutes,         // 발령
      ...dtsRoutes,         // 근퇴
      ...elaRoutes,         // 결재
      ...payRoutes,         // 보상
      ...devRoutes,         // 개발
      ...generatedRoutes,   // DEV0030 빌더 생성 라우트(기계 소유 - _generated.manifest.json SSOT)
    ],
  },
];

export default routes;
